export enum ExitType {
    Sale = 0,
    Refinance = 1,
}
